<script lang="ts">
</script>

<div class="container">
  <p>Denne siden finnes ikke.</p>
</div>

<style>
  .container {
    text-align: center;
  }
</style>
